import { EventContextProvider } from "@codat/analytics";
import React from "react";
import { Route, RouteProps } from "react-router-dom";

interface TrackedRouteProps extends RouteProps {
  name: string;
  component: React.ComponentType;
  path: string;
}

const TrackedRoute = ({
  name,
  component,
  path,
  ...props
}: TrackedRouteProps) => (
  <EventContextProvider name={name}>
    <Route component={component} path={path} {...props} />
  </EventContextProvider>
);

export default TrackedRoute;
